import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { MarketingCampaignsState } from "./types"
import { fetchCampaigns, fetchChannels } from "./marketing-campaigns-thunk"
import { ErrorType } from "@/shared/types"

const initialState: MarketingCampaignsState = {
    campaigns: [],
    isCampaignsLoading: false,
    isCampaignsFirstLoad: true,
    campaignsError: null,
    
    channels: [],
    isChannelsLoading: false,
    isChannelsFirstLoad: true,
    channelsError: null,

    page: 1,
    search: "",
    limit: 50,
    totalPages: 0
}

const marketingCampaignsSlice = createSlice({
    name: 'marketingCampaigns',
    initialState,
    reducers: {
        setPage: (state, action: PayloadAction<number>) => {
            state.page = action.payload
        },
        setSearch: (state, action: PayloadAction<string>) => {
            state.search = action.payload
            state.page = 1
        }
    },
    extraReducers(builder) {
        builder
        .addCase(fetchCampaigns.pending, (state) => {
            state.isCampaignsLoading = true
        })
        .addCase(fetchCampaigns.fulfilled, (state, action) => {
            state.isCampaignsFirstLoad = false
            state.isCampaignsLoading = false
            state.campaigns = action.payload.items
            state.totalPages = action.payload.totalPages
            state.campaignsError = null
        })
        .addCase(fetchCampaigns.rejected, (state, action) => {
            state.campaignsError = action.payload as ErrorType
            state.isCampaignsLoading = false
        })
        .addCase(fetchChannels.pending, (state) => {
            state.isChannelsLoading = true
        })
        .addCase(fetchChannels.fulfilled, (state, action) => {
            state.isChannelsFirstLoad = false
            state.isChannelsLoading = false
            state.channels = action.payload
            state.channelsError = null
        })
        .addCase(fetchChannels.rejected, (state, action) => {
            state.channelsError = action.payload as ErrorType
            state.isChannelsLoading = false
        })
    },
})

export default marketingCampaignsSlice.reducer
export const { setPage, setSearch } = marketingCampaignsSlice.actions